import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, MatTableDataSource, MatSort } from '@angular/material';
import { APIImportPreferenceService } from '../../_services/import-preference/API-import-preference';
import { APIHeaderService } from '../../_services/header/API-header';
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { DataSource } from '@angular/cdk/table';
import { Observable } from 'rxjs/Observable';
import { Constants } from '../../../../_utils/Constants';
import { $DBManagerService } from '../../../../_helpers/DB/DBManager.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { formatDate } from '@angular/common';
import { saveAs as importedSaveAs } from "file-saver";
import { $ModalManagerService } from '../../../../_helpers/Modals/ModalManager.service';
import { Router } from '@angular/router';

const today = new Date();
var time_today = today.getTime();
let now = new Date();
const currentdat = formatDate(now, 'dd-MM-yyyy', 'en-US', '+0530');


@Component({
  selector: 'app-header-summary',
  templateUrl: './header-summary.component.html',
  styleUrls: ['./header-summary.component.css']
})
export class HeaderSummaryComponent implements OnInit { 
  dataSubject = new BehaviorSubject<any[]>([]);
  displayedColumns: string[] = ['BatchId', 'createdAt', 'NCPR_File_Name', 'Input_Count','Success_Count', 'Failure_Count', 'Export_File'];
  /*  'Uploaded By', */
  form1: any = {};
  fetchedData: any;
  filterForm: FormGroup;
  queryData: any={};
  searchError: boolean = false;
  onSubmitFilter(filterForm) {
    console.log(filterForm.value);

    	
	var param = filterForm.search;
  if(typeof param === 'undefined' || param == null )
    param ="";
  else
    param = filterForm.search;

  var fdate = filterForm.startDate;
  var ldate = filterForm.endDate;

if(typeof fdate === 'undefined' || fdate == null )
    fdate ="";
  else
    fdate = formatDate(filterForm.startDate, 'yyyy-MM-dd', 'en-US', '+0530');
  if(typeof ldate === 'undefined' || ldate == null )
    ldate = "";
  else
    ldate = formatDate(filterForm.endDate, 'yyyy-MM-dd', 'en-US', '+0530'); 
console.log("param --- ",param);
  
  if( (filterForm.searchBy == undefined || filterForm.searchBy == null ) && ( param == undefined || param == null) && fdate==""){
     this.searchError = true;
}
else{
this.searchError = false;
const searchBy = filterForm.searchBy; 
  

  console.log("fdate", fdate);

  let entityId = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_ID);
  
this.queryData = {
  Start_Date:fdate,
  End_Date:ldate,
  param: param,
  filterType:searchBy,
  peid:entityId
}

    this.head.getHeaderSummaryFilter(this.queryData)
      .subscribe(r => {

        console.log("r" + r);
        console.log(JSON.stringify(r));
        let rr = JSON.stringify(r);

        console.log("r.Data" + r.Data);
        console.log("r.Data" + JSON.stringify(r.Data));
        this.fetchedData = JSON.stringify(r.Data);
        console.log("this.fetchedData" + this.fetchedData);
        console.log("ArrayData" + JSON.parse(this.fetchedData));

        this.dataSource = r.Data;
        this.onChangeDataSource(r.Data);

      });
    }
  }
  onChangeDataSource(value) {
    this.dataSubject.next(value);
    this.dataSource = new MatTableDataSource();

    this.dataSource = new MatTableDataSource(value);
    this.dataSource.paginator = this.paginator;
    console.log("dataSource : ", this.dataSource);
  }

  public preferencesummary: any;
  public NCPR_File_Name: any;
  applyFilter(filterValue: string) {
    console.log("in filter");
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
  GetDND_COMPLAINTS_TSP: any;
  dataSource: any;
  public reqId: any;
  public ncprFilename: any;
  public reqDate: any;
  public uploadedBy: any;
  public userName: any;
  public entityI: any;
  form: any = {};
  startDate1: any;

  @ViewChild(MatPaginator) paginator: MatPaginator;

  @ViewChild(MatSort) sort: MatSort;
  constructor(
    private imp: APIImportPreferenceService,
    private head: APIHeaderService,
    private db: $DBManagerService,
    private fb: FormBuilder,
    private $modal: $ModalManagerService,
    private router: Router,

  ) {


  }
  preferenceSummary: FormGroup;

  ngOnInit() {
    if (this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_REF_NO_LOGIN) == null && this.db.get(Constants.SESSSION_STORAGE, Constants.Entity_EmailID) == null) {
      this.router.navigate(['/']);
    }

    this.reqId = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_NAME);
    this.userName = this.db.get(Constants.SESSSION_STORAGE, Constants.USER_NAME);
	this.entityI = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_ID);

    this.preferenceSummary = this.fb.group({
      fromDate: [''],
      toDate: [''],
      status: ['']
    });
    console.log(this.startDate1)
    this.getBulkHeaderSummary();
  }

    getSubstring(filename){  
		return filename.substring(filename.indexOf('.') + 1)
	}
	
  downloadFailureFile(Batch_Id) {

    console.log("Batch_Id from ts", Batch_Id)
    this.head.downloadHeaderFile(Batch_Id).subscribe(r => {
      var fileName = Batch_Id + 'Records.csv';
      importedSaveAs(r, fileName)
      this.$modal.successModal({ 
        title: 'Header Summary',
        msg: 'File has been downloaded Successfully'
      });
    })

  }
  getBulkHeaderSummary() {

    var data = {
      peid: this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_ID)
    }
    this.head.getbulkHeaderSummary(data).subscribe({ 
      next: value => {
        this.dataSubject.next(value);
        this.dataSource = new MatTableDataSource();

        this.dataSource = new MatTableDataSource(value);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        console.log("dataSource : ", this.dataSource);

      }
    });
  }



  private downloadFile(res: any, filename: string): void {

    console.log("filename", filename)

    const url = window.URL.createObjectURL(res);
    const a = document.createElement('a');
    document.body.appendChild(a);
    a.setAttribute('style', 'display: none');
    a.href = url;
    a.download = filename;
    a.click();
    window.URL.revokeObjectURL(url);
    a.remove();
  }
  getPreferenceSummary() {
    console.log("calling preferencesummary ")

    this.imp.getPreferenceSummary()
      .subscribe(m => {
        this.preferencesummary = m;
        console.log("preferencesummary :::: ", JSON.stringify(this.preferencesummary));
        console.log("preferencesummary idddd :::: ", this.preferencesummary[0]._id);
        this.preferencesummary.map((val, i) => {


          /*   this.preferencesummary[i].NCPR_File_Name = this.ncprFilename;
             this.preferencesummary[i]._id = this.reqId;
             this.preferencesummary[i].Upload_Date = this.reqDate;
             this.preferencesummary[i].Entity_Name = this.uploadedBy;*/
          this.db.set(Constants.SESSSION_STORAGE, Constants.NCPRFILENAME, this.preferencesummary[i].NCPR_File_Name);
          this.db.set(Constants.SESSSION_STORAGE, Constants.NCPRREQUESTID, this.preferencesummary[i].BatchId);
          this.db.set(Constants.SESSSION_STORAGE, Constants.NCPRREQUESTDATE, this.preferencesummary[i].Upload_Date);
          this.db.set(Constants.SESSSION_STORAGE, Constants.ENTITY_NAME, this.preferencesummary[i].Entity_Name);


        })

      });
  }
  onApplyFilter1(filterForm1) {
    console.log(filterForm1.value);
  }
  reset() {
 
    //this.afterReset();
    this.getBulkHeaderSummary();
  
  }
 /* afterReset() {
    this.imp.getPreferenceSummary().subscribe({
      next: value => {
        this.dataSubject.next(value);
        this.dataSource = new MatTableDataSource();

        this.dataSource = new MatTableDataSource(value);
        this.dataSource.paginator = this.paginator;
      

      }
    });
  }*/

}
export class MyDataSource extends DataSource<any[]> { 

  constructor(private subject: BehaviorSubject<any[]>) {
    super();
  }
  connect(): Observable<any[]> {
    return this.subject.asObservable();
  }
  disconnect(): void {

  }

}


